import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from '@bingads-webui-react/radio';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';

import { CommentsField } from './comments-field';
import { REASON_TABLE } from './reason-const';

const OTHER_REASON = 'Other';
const defaultReasonIds = [
  'NotInterested',
  'OtherSolution',
  'DoNotUnderstand',
  'NotApplicable',
  'SpendNoMore',
  OTHER_REASON,
];

export class FeedbackForm extends React.PureComponent {
  static propTypes = {
    recommendationDescription: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isProvideFeedbackOnly: PropTypes.bool,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    readOnly: PropTypes.bool.isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    isProvideFeedbackOnly: false,
    type: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      reasonId: null,
      reasonNote: '',
    };
  }

  handleReasonChange = (e) => {
    this.setState({
      reasonId: e.target.id,
    });
  };

  handleCommentsChange = (value) => {
    this.setState({
      reasonNote: value,
    });
  };

  handleCommentsFocus = () => {
    if (this.state.reasonId === null) {
      this.setState({
        reasonId: OTHER_REASON,
      });
    }
  };

  render() {
    const { reasonId, reasonNote } = this.state;
    const {
      recommendationDescription,
      i18n,
      onSubmit,
      onCancel,
      isProvideFeedbackOnly,
      readOnly,
      type,
    } = this.props;

    let reasonIds = defaultReasonIds;
    switch (type) {
      case RECOMMENDATION_TYPES.FIX_AD_TEXT:
        reasonIds = REASON_TABLE[RECOMMENDATION_TYPES.FIX_AD_TEXT];
        break;
      case RECOMMENDATION_TYPES.FIX_AD_DESTINATION:
        reasonIds = REASON_TABLE[RECOMMENDATION_TYPES.FIX_AD_DESTINATION];
        break;
      case RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY:
        reasonIds = REASON_TABLE[RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY];
        break;
      default:
        break;
    }

    const title = i18n.getString(
      isProvideFeedbackOnly ? 'Recommendation_Feedback_Submit_Title' : 'Recommendation_Feedback_Reject_Title',
      { recommendationDescription }
    );

    const submitText = i18n.getString('Recommendation_Feedback_Submit_Action');

    const hasUserInput = !isProvideFeedbackOnly || reasonNote !== '';
    const submitDisabled = readOnly || !hasUserInput;

    return (
      <div className="recommendation-feedback-form">
        <button
          className="close closeimage"
          onClick={onCancel}
          aria-label={i18n.getString('Button_Close')}
        />
        <h3>{title}</h3>

        {!isProvideFeedbackOnly &&
          <React.Fragment>
            <p>{i18n.getString('Recommendation_Feedback_Instructions')}</p>
            <div className="reasons form-group">
              {_.map(reasonIds, id => (
                <Radio
                  key={id}
                  id={id}
                  name="reason"
                  checked={id === reasonId}
                  value={id}
                  onChange={this.handleReasonChange}
                >
                  {i18n.getString(`Recommendation_Feedback_Reason_${id}`)}
                </Radio>
              ))}
            </div>
          </React.Fragment>
        }

        <div className="comments form-group">
          <CommentsField
            id="comments"
            value={reasonNote}
            onChange={this.handleCommentsChange}
            i18n={i18n}
            onFocus={this.handleCommentsFocus}
            isProvideFeedbackOnly={isProvideFeedbackOnly}
          />
        </div>

        <div className="actions form-inline">
          <button
            disabled={submitDisabled}
            className="btn btn-hero btn-primary submit"
            onClick={() => onSubmit({
              ReasonId: reasonId,
              ReasonNote: reasonNote,
            })}
          >
            {submitText}
          </button>
          <button className="btn btn-default cancel" onClick={onCancel}>{i18n.getString('Recommendation_Feedback_Cancel')}</button>
        </div>
      </div>
    );
  }
}
